'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationSelector = exports.mapDispatchToProps = exports.mapStateToProps = exports.LocationSelectorUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _Sagas = require('decorators/Sagas');

var _decorator = require('helpers/decorator');

var _bound = require('redux/saga/entities/bound');

var _homepage = require('redux/modules/features/homepage');

var _msas = require('redux/saga/selectors/msas');

var _LocationInputContainer = require('components/LocationInput/LocationInputContainer');

var _locationSelector = require('./location-selector.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  locationLeadIn: {
    id: 'location-selector.label',
    defaultMessage: 'I’m in'
  },
  locationPlaceholder: {
    id: 'location-selector.placeholder',
    defaultMessage: ' enter city name'
  }
});

var LocationSelectorUnwrapped = exports.LocationSelectorUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(LocationSelectorUnwrapped, _PureComponent);

  function LocationSelectorUnwrapped() {
    var _ref;

    (0, _classCallCheck3.default)(this, LocationSelectorUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = LocationSelectorUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(LocationSelectorUnwrapped)).call.apply(_ref, [this].concat(args)));

    _this.handleLocationChange = _this.handleLocationChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LocationSelectorUnwrapped, [{
    key: 'handleLocationChange',
    value: function handleLocationChange(loc) {
      if (loc) {
        var lat = loc.lat,
            lon = loc.lon;

        this.props.onChangeLocation(lat, lon);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          locationName = _props.locationName,
          intl = _props.intl;


      return _react2.default.createElement(_LocationInputContainer.LocationInputContainer, {
        initialValue: locationName,
        inputAttributes: { placeholder: intl.formatMessage(messages.locationPlaceholder) },
        label: label || intl.formatMessage(messages.locationLeadIn),
        onChange: this.handleLocationChange,
        style: 'underlined'
      });
    }
  }]);
  return LocationSelectorUnwrapped;
}(_react.PureComponent);

LocationSelectorUnwrapped.propTypes = {
  label: _propTypes2.default.string,
  locationName: _propTypes2.default.string,
  onChangeLocation: _propTypes2.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var msa = (0, _msas.msaById)(_bound.msas.data(state), (0, _homepage.selectMsaId)(state)) || {};
  return {
    locationName: msa.city || msa.name || ''
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onChangeLocation: _locationSelector.changeLocation
};

var LocationSelector = exports.LocationSelector = (0, _decorator.decorateWith)(_reactIntl.injectIntl, (0, _Sagas.withSagas)({ load: _locationSelector.loadSaga, watch: _locationSelector.watchSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(LocationSelectorUnwrapped);